import React, { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './BidderAccount.css';

const logo = require('../../style/assets/images/ScrubPlanBidInvite.png');

export const BidderAccountHeader: FC = () => (
	<header className="bidder-account-header">
		<a
			aria-label="ScrubPlan bidder profile"
			className="bidder-account-brand"
			href="/bidder/profile"
		>
			<img alt="" aria-hidden="true" src={logo} />
			<span>Bidder Portal</span>
		</a>
		<nav aria-label="Bidder account">
			<a href="/bidder/profile">Company profile</a>
			<a href="/signout">Sign out</a>
		</nav>
	</header>
);

const BidderAccountLayout: FC<{ children: ReactNode }> = ({ children }) => {
	const { pathname } = useLocation();
	const inWorkspace = pathname.indexOf('/bidder/invitations/') === 0;
	return (
		<div className="bidder-account-shell">
			<BidderAccountHeader />
			<main className={inWorkspace ? 'bidder-account-workspace' : 'bidder-account-main'}>
				{inWorkspace && (
					<a className="bidder-account-back" href="/bidder/profile">
						<FaArrowLeft aria-hidden="true" /> Back to profile
					</a>
				)}
				{children}
			</main>
		</div>
	);
};

export default BidderAccountLayout;
